import React from 'react';
import '../App.css';

function Loading() {
  return (
    <div className="loading">
        <h1> We'll Be Right Back! </h1>
    </div>
  );
}

export default Loading;
